import { call, put, select } from "redux-saga/effects";
import { Creators as ManufacturerActions } from "../ducks/manufacturer";
import {
  getManufacturersDropdown,
  saveManufacturer,
} from "../../services/manufacturerService";
import { notification } from "antd";

export function* listDropDownManufacturer(action) {
  try {
    const response = yield call(getManufacturersDropdown, action.payload);
    const allManufacturers = response?.data?.results || response?.data || [];
    const onlyActives = allManufacturers.filter(
      (manufacturer) => manufacturer.status === "Active",
    );
    yield put(
      ManufacturerActions.getDropdownManufacturersSuccess(onlyActives),
    );
  } catch (error) {
    yield put(ManufacturerActions.getDropdownManufacturersError(error));
  }
}

export function* storeManufacturer(action) {
  try {
    const response = yield call(saveManufacturer, action.payload);
    const newManufacturer = response?.data?.results || response?.data || {};
    const { translation } = yield select((state) => state.app);

    notification.success({
      message: translation.manufacturer.messages.createSuccess,
    });

    yield put(ManufacturerActions.saveManufacturerSuccess(newManufacturer));
    yield put(
      ManufacturerActions.getDropdownManufacturers(
        action.payload.groupId,
        action.payload.farmId,
      ),
    );
    yield put(ManufacturerActions.refreshDrowpDownList(newManufacturer));
  } catch (error) {
    const { translation } = yield select((state) => state.app);
    const errorCode = error?.response?.data?.code;

    if (errorCode === 5044) {
      notification.error({
        message: translation.manufacturer.messages.duplicateName,
        description: translation.manufacturer.messages.duplicateNameDescription,
      });
    } else {
      notification.error({
        message: translation.manufacturer.messages.createError,
      });
    }

    yield put(ManufacturerActions.saveManufacturerError(error));
  }
}
